module.exports = __webpack_public_path__ + "static/media/boy-icon.85043042.png";